import * as Yup from "yup";

const cleaningSchema = Yup.object().shape({
  homeType: Yup.string()
    .required("Please select type of home")
    .oneOf(
      ["Condo", "Townhouse", "Detached", "Duplex", "Mobile Home"],
      "Please select a valid home type"
    ),

  rooms: Yup.number()
    .required("Please enter number of rooms")
    .typeError("Number of rooms must be a number")
    .min(1, "At least 1 room required")
    .max(15, "Maximum 15 rooms allowed"),

  washrooms: Yup.number()
    .required("Please enter number of washrooms")
    .typeError("Number of washrooms must be a number")
    .min(1, "At least 1 washroom required")
    .max(10, "Maximum 10 washrooms allowed"),

  supplies: Yup.string()
    .required("Please select supplies")
    .oneOf(["Yes", "No"], "Please select a valid option"),

  cleaningType: Yup.string()
    .required("Please select a cleaning type"),
});

export default cleaningSchema;
